import { hide, unhide } from "../../utils";
import { ElemID } from "../editor/constants";
import { EventBus, Events } from "../eventBus";

// Auto-initialise component when app loaded
EventBus.subscribe(Events.APP_LOADED, function () {
  initComponent();
});

const uploaderComponent = document.getElementById(ElemID.UPLOADER_COMPONENT);
const dropzone = document.getElementById("dropzone");
const dropzoneButton = document.getElementById("dropzone-button");
const fileInputElem = document.getElementById("uploader-file-input");
const dropzoneControls = document.getElementById("dropzone-controls");
const dropzoneActiveLabel = document.getElementById("dropzone-active-label");
const dropzoneError = document.getElementById("dropzone-error");
const dropzoneErrorText = document.getElementById("dropzone-error-text");

function hideComponent() {
  hide(uploaderComponent);
}

function initComponent() {
  // add event handlers for dropzone
  dropzone.addEventListener("dragenter", dragenter, false);
  dropzone.addEventListener("dragleave", dragleave, false);
  dropzone.addEventListener("dragover", dragover, false);
  dropzone.addEventListener("drop", onDrop, false);

  // link form action to upload handler
  fileInputElem.addEventListener(
    "change",
    function () {
      handleFiles(this.files);
    },
    false,
  );

  // trigger file dialog on button click
  dropzoneButton.addEventListener("click", function () {
    hideError();
    fileInputElem.click();
  });

  // make it visible
  unhide(uploaderComponent);
}

function handleFiles(files) {
  // files will be a FileList object (https://developer.mozilla.org/en-US/docs/Web/API/FileList)
  let pdfFile = null;

  // If user drops more than one file, we will pick out only PDF files. As long as there is only one PDF file,
  // we will use that and proceed. Otherwise, show error.
  for (let i = 0; i < files.length; i++) {
    let f = files.item(i);
    if (f.type === "application/pdf") {
      if (pdfFile) {
        showError("Please provide only one PDF file.");
        return;
      } else {
        pdfFile = f;
      }
    }
  }

  if (!pdfFile) {
    // user provided one or more files, but none are PDF
    showError("A PDF file is required.");
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    hideComponent();
    EventBus.emit(Events.PDF_UPLOADED, {
      data: e.target.result,
      filename: pdfFile.name,
    });
  };
  reader.readAsArrayBuffer(pdfFile);
}

function onDrop(e) {
  e.stopPropagation();
  e.preventDefault();

  if (dragDepth !== 0) {
    dragDepth = 0;
    setDropzoneInactive();
  }

  handleFiles(e.dataTransfer.files);
}

function dragover(e) {
  // !! this is important. Without this, drop event won't work properly
  e.stopPropagation();
  e.preventDefault();
}

// ref counter for dragenter/dragleave events. This is required because enter+leave also fired
// when dragging over children elements.
let dragDepth = 0;

function dragenter(e) {
  e.stopPropagation();
  e.preventDefault();

  hideError();

  if (dragDepth++ === 0) {
    setDropzoneActive();
  }
}

function dragleave(e) {
  e.stopPropagation();
  e.preventDefault();
  if (--dragDepth === 0) {
    setDropzoneInactive();
  }
}

function setDropzoneActive() {
  dropzone.classList.add("dropzone-active");
  hide(dropzoneControls);
  unhide(dropzoneActiveLabel);
}

function setDropzoneInactive() {
  dropzone.classList.remove("dropzone-active");
  unhide(dropzoneControls);
  hide(dropzoneActiveLabel);
}

function showError(message) {
  dropzoneErrorText.textContent = message;
  unhide(dropzoneError);
}

function hideError() {
  hide(dropzoneError);
}
